export default "__VITE_PUBLIC_ASSET__7bad75f1__"